import * as React from "react";
import classnames from "classnames";
/* empty css                    */
const SuggestionItem = ({
  className,
  active,
  suggestion,
  setFocus,
  onBlur,
  setHovered,
  onSuggestionClick,
  ...rest
}) => {
  const { title, subTitle, cursor, id } = suggestion;
  const onFocus = React.useCallback(() => setFocus(cursor), [setFocus, cursor]);
  const onMouseEnter = React.useCallback(() => setHovered(suggestion), [setHovered, suggestion]);
  const onMouseLeave = React.useCallback(() => setHovered(void 0), [setHovered]);
  const onClick = React.useCallback(() => onSuggestionClick(id), [id, onSuggestionClick]);
  return /* @__PURE__ */ React.createElement(
    "li",
    {
      ...rest,
      role: "presentation",
      className: classnames(
        "autocomplete-suggestions-item",
        {
          "autocomplete-suggestions-item--active": active
        },
        className
      )
    },
    /* @__PURE__ */ React.createElement(
      "button",
      {
        id: `autocomplete-suggestion-item-${cursor}`,
        role: "option",
        "aria-selected": active,
        onFocus,
        onBlur,
        onMouseEnter,
        onMouseLeave,
        onClick,
        className: "autocomplete-suggestions-item__button"
      },
      /* @__PURE__ */ React.createElement("span", { className: "autocomplete-suggestions-item__button--title" }, title),
      subTitle && /* @__PURE__ */ React.createElement(
        "span",
        {
          "data-t": "suggestion-sub-title",
          className: "autocomplete-suggestions-item__button--subtitle"
        },
        " ",
        subTitle
      )
    )
  );
};
export {
  SuggestionItem as default
};
//# sourceMappingURL=SuggestionItem.js.map
